import React, { useEffect, useState } from 'react';
import '../css/AIModal.css';

const aiAds = [
  {
    title: 'Voice Clone AI – Biometric Verification App',
    description: 'Face verification system with selfie capture and voice clone tech using FastAPI + React.',
    imageUrl: 'https://i.ibb.co/DHWJVr1Z/Screenshot-2025-04-30-at-9-49-11-AM.png'
  },
  {
    title: 'RamizKaraEski GPT — Your Personal AI Side-Kick',
    description: 'A “full-stack” assistant woven into your own toolchain. It marries a large-language-model brain with direct integrations to your Gmail, Google Calendar, macOS utilities, and any custom endpoints you bolt on.',
    imageUrl: 'https://i.ibb.co/8g1YrLqC/2.png'
  }
];

const AIModal = () => {
  const [show, setShow] = useState(true);
  const [index, setIndex] = useState(0);

  const next = () => setIndex((prev) => (prev + 1) % aiAds.length);
  const prev = () => setIndex((prev) => (prev - 1 + aiAds.length) % aiAds.length);

  // Auto-close after 20s
  useEffect(() => {
    const timeout = setTimeout(() => setShow(false), 20000);
    return () => clearTimeout(timeout);
  }, []);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => next(), 5000);
    return () => clearInterval(interval);
  }, []);

  if (!show) return null;

  return (
    <div className="ai-modal-overlay">
      <div className="ai-modal">
        <button className="close-btn" onClick={() => setShow(false)}>✕</button>
        <img
          src={aiAds[index].imageUrl}
          alt={aiAds[index].title}
          className="ai-modal-image"
        />
        <h2>{aiAds[index].title}</h2>
        <p>{aiAds[index].description}</p>

        <div className="modal-controls">
          <button onClick={prev}>←</button>
          <button onClick={next}>→</button>
        </div>

        <div className="slide-indicator">
          {aiAds.map((_, i) => (
            <div
              key={i}
              className={`slide-dot ${i === index ? 'active' : ''}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIModal;
